import { QRCodeSVG } from "qrcode.react"
import { LoginButton } from "../login-button"

interface TotpSetupProps {
    userEmail: string
    nextStep: { totpSetupDetails: any }
    setNextStep: React.Dispatch<any>
}

export const TotpSetup: React.FC<TotpSetupProps> = ({ userEmail, nextStep, setNextStep }) => {
    const onNextStep = () => {
        setNextStep({ signInStep: 'CONFIRM_SIGN_IN_WITH_TOTP_CODE' })
    }

    const resTotpUri = nextStep.totpSetupDetails.getSetupUri('AudiTech Backoffice', userEmail)

    return <section className="totp-setup password-login-container">
        <p>Scan the QR Code using authenticator app and click on "Next"</p>
        <QRCodeSVG className="qr-code" value={resTotpUri.href} size={200} />
        <LoginButton txt="next" action={onNextStep} isFullColor={false} />
    </section>
}
